/* eslint-disable max-lines-per-function */

import { createTranslatedText } from '@dreryk/react-common';
import { Heading, NotFoundPanel, Scroll } from '@dreryk/react-components';

import { DocumentTemplateForm } from '~libs.desktop.shared.document-template';
import { visitPaths } from '~libs.desktop.shared.paths';

import { VisitConsentApproveAndPrintAction } from './actions/VisitConsentApproveAndPrintAction';
import { ConsentTemplateFormLoader } from './ConsentTemplateForm.loader';
import { ConsentTemplateFormLeavingGuard } from './ConsentTemplateFormLeavingGuard';
import { StyledDocumentTemplateForm } from './ConsentTemplatePanel.styled';

type ConsentTemplatePanelProps = Readonly<{
   readonly patientId: number;
}>;

export const ConsentTemplatePanel = (props: ConsentTemplatePanelProps): JSX.Element => {
   const { printTemplateId, visitId } = visitPaths.useConsentTemplateParams();

   if (!printTemplateId) {
      return <NotFoundPanel />;
   }

   return (
      <Scroll testId={'consentTemplate'}>
         <ConsentTemplateFormLoader visitId={visitId} printTemplateId={printTemplateId}>
            {({ consentTemplate, consentTemplateDraft }) => (
               <StyledDocumentTemplateForm direction={'column'} gap={7} flex={'1'}>
                  <Heading testId={'name'} type='h1' margin={0} content={createTranslatedText(consentTemplate.name)} />
                  <DocumentTemplateForm documentTemplate={consentTemplate} documentTemplateDraft={consentTemplateDraft}>
                     {({ handleSubmit, handleSubmitDraft, formState, markPristine }) => (
                        <>
                           <ConsentTemplateFormLeavingGuard
                              handleSubmitDraft={handleSubmitDraft}
                              visitId={visitId}
                              printTemplateId={printTemplateId}
                              formState={formState}
                           />
                           <VisitConsentApproveAndPrintAction
                              patientId={props.patientId}
                              visitId={visitId}
                              printTemplateId={printTemplateId}
                              handleSubmit={handleSubmit}
                              markPristine={markPristine}
                           />
                        </>
                     )}
                  </DocumentTemplateForm>
               </StyledDocumentTemplateForm>
            )}
         </ConsentTemplateFormLoader>
      </Scroll>
   );
};
